export default __webpack_public_path__ + "static/media/belly-photo-EN.0f943da1.png";